export const notificationKeys = {
  noMoreRecos: 'noMoreRecosForYou',
  overDue: 'isOverdue',
  successReco: 'successReco',
  errorStageAndBook: 'errorStageAndBook',
  bundleCancel: 'bundleCancel',
  enclosedCancel: 'enclosedCancel',
  driveawayCancel: 'driveawayCancel',
  errorEditJob: 'errorEditJob',
  successEditJob: 'successEditJob',
  errorUploadFile: 'errorUploadFile',
  errorDeleteFile: 'errorDeleteFile',
  errorCancelJob: 'errorCancelJob',
  errorCancelJobTimeout: 'errorCancelJobTimeout',
  isFinalized: 'isFinalized',
  successEditVehicleInfo: 'successEditVehicleInfo',
  errorEditVehicleInfo: 'errorEditVehicleInfo',
  successInviteUser: 'successInviteUser',
  errorInviteUser: 'errorInviteUser',
  successDeleteUser: 'successDeleteUser',
  errorDeleteUser: 'errorDeleteUser',
  successUpdateUser: 'successUpdateUser',
  errorUpdateUser: 'errorUpdateUser',
  jobPastDuebySLADate: 'jobPastDuebySLADate',
  specialAnnouncement: 'specialAnnouncement',
  HVVVerification: 'HVVVerification',
  avoidScams: 'avoidScams',
};
